<template>
  <div @click="clickConfirm" class="card-body"
       v-bind:videoId="video.id"
       v-bind:title="video.url"
       v-bind:description="video.title"
       v-bind:duration="video.duration"
  >
    <img class="card-img-top" :src="video.bestThumbnail.url" alt="YouTube thumbnail">
    <div class="card-body">
      <h5 class="card-title">{{ video.url }}</h5>
      <!-- h6
        class="card-subtitle mb-2 text-muted"
      >{{ video.snippet.channelTitle }} | {{ video.snippet.publishedAt | formatDate }}</h6 -->
      <p class="card-text">{{ video.title }}</p>
    </div>
    <dialog-bar v-model="sendVal"
                type="confirm"
                v-bind:title="video.url"
                v-bind:content="video.title"
                v-bind:videoId="video.id"
                v-bind:duration="video.duration"
                v-on:cancel="clickCancel" @danger="clickDanger" @confirm="clickConfirm"></dialog-bar>
  </div>
</template>

<script>
import axios from "axios";
import dialogBar from "./layout/dialog.vue";

export default {
  name: 'VideoGridItem',
  props: ['video','placeKey','roomNo'],
  components:{
    'dialog-bar': dialogBar,
  },
  data(){
    return{
      sendVal: false,
    }
  },
  methods: {
    openMask(){
      this.sendVal = true;
    },
    clickCancel(){
      console.log('点击了取消');
    },
    clickDanger(){
      console.log('这里是danger回调');
    },
    clickConfirm(){
      console.log('点击了confirm:videoId='+this.video.id);
      console.log('点击了confirm:title='+this.video.url);
      console.log('点击了confirm:content='+this.video.title);
      console.log('点击了confirm:duration='+this.video.duration);
      //console.log('点击了confirm:trackid='+data.trackid);
      //console.log('点击了confirm:first='+data.first);
      //console.log('点击了confirm:key='+data.key);
      let apiUrl = "https://ktvyb.singtag.com/api/ytb/videoClickPost"; //正式环境
      let sendData = {"placeKey":this.placeKey,
        "roomNo":this.roomNo,
        "videoId":this.video.id,
        "title":this.video.url,
        "description":this.video.title,
        "duration":this.video.duration
        //"trackid":data.trackid,
        //"first":data.first,
        //"key":data.key
        };
      axios
          .post(apiUrl,sendData)
          .then(res => {
            //this.videos = res.data.data.items;
            if(res.data.code == 1201 || res.data.code == 1002) {
              alert("出错了:"+res.data.message);
            }
            else {
              alert("点播成功/Success");
            }
          })
          .catch(error => {
            console.log(error);
            alert("出错了:"+error);
          });
    }
  },
};
</script>
